module.exports = __webpack_public_path__ + "img/back_pocket_height.763f214b.png";